module.exports = __webpack_public_path__ + "static/coding-browser-ff89e70294d41ead92c3d59c5edb86c3.png";